import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Box, DBox, NotFound } from 'pages';

class App extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        // console.log("App shouldComponentUpdate()");
        return false;
    }

    render() {
        return (
            <div>        
                <Switch>
                    {/* <Route exact path="/box/:tenantCode/:boxCode" component={Box} /> */}
                    <Route path="/box/:tenantCode/:boxCode" component={DBox}/>
                    
                    <Route>
                        <NotFound></NotFound>
                    </Route>
                </Switch>
                
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/shared/App.js